<div class="row wrapper border-bottom white-bg page-heading">
  <div class="col-lg-4">
    <h2>Projeto - Link Legislação</h2>
    <h3>Admin</h3>
  </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-content box-content">
          <div class="info-page">
            <h3>{{ actionLabel }} </h3>
          </div>

          <form [formGroup]="form" (ngSubmit)="salvar()">
            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Nome<sup class="text-danger ms-2">*</sup></label>
                <input type="text" id="name" class="form-control" formControlName="name" required="required" />
                <app-field-message [field]="fieldMessageRequired('name')" [erros]="fieldErros('name')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Url<sup class="text-danger ms-2">*</sup></label>
                <input type="text" id="url" class="form-control" formControlName="url" required="required" />
                <app-field-message [field]="fieldMessageRequired('url')" [erros]="fieldErros('url')"></app-field-message>
              </div>
            </div>

            <div class="form-group row m-b">
              <div class="col-sm-4">
                <label class="col-sm-12 pb-1">Dica</label>
                <textarea type="text" id="tooltip" class="form-control" formControlName="tooltip" maxlength="3000" rows="4"></textarea>
                <app-field-message [field]="fieldMessageRequired('tooltip')" [erros]="fieldErros('tooltip')"></app-field-message>
              </div>
            </div>

            <div class="hr-line-dashed"></div>
            <div class="form-group row d-flex justify-content-end">
              <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
                <button class="btn btn-white m-r-xs" type="button" (click)="voltar()">Voltar</button>
                <button class="btn btn-primary" type="submit">Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>